import {
  GET_LABREQUESTREPORT,
  GET_LABREQUESTREPORT_FAIL,
  GET_LABREQUESTREPORT_SUCCESS,
  GET_LABREQUESTREPORTS,
  GET_LABREQUESTREPORTS_FAIL,
  GET_LABREQUESTREPORTS_SUCCESS,
  ADD_NEW_LABREQUESTREPORT,
  ADD_LABREQUESTREPORT_SUCCESS,
  ADD_LABREQUESTREPORT_FAIL,
  UPDATE_LABREQUESTREPORT,
  UPDATE_LABREQUESTREPORT_SUCCESS,
  UPDATE_LABREQUESTREPORT_FAIL,
  DELETE_LABREQUESTREPORT,
  DELETE_LABREQUESTREPORT_SUCCESS,
  DELETE_LABREQUESTREPORT_FAIL,
  SET_STATE_LABREQUESTREPORT
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LABREQUESTREPORT,
  payload: loading,
})

export const getLabRequestReports = ( params ) => ({
  type: GET_LABREQUESTREPORTS,
  payload: { params },
})

export const getLabRequestReportsSuccess = (labRequestReports, totalPages, currentPage) => ({
  type: GET_LABREQUESTREPORTS_SUCCESS,
  payload: { labRequestReports:labRequestReports, total:totalPages, currentPage:currentPage}
})

export const getLabRequestReportsFail = error => ({
  type: GET_LABREQUESTREPORTS_FAIL,
  payload: error,
})

export const addNewLabRequestReport = labRequestReport => ({
  type: ADD_NEW_LABREQUESTREPORT,
  payload: labRequestReport,
})

export const addLabRequestReportSuccess = labRequestReport => ({
  type: ADD_LABREQUESTREPORT_SUCCESS,
  payload: labRequestReport,
})  

export const addLabRequestReportFail = error => ({
  type: ADD_LABREQUESTREPORT_FAIL,
  payload: error,
})

export const updateLabRequestReport = labRequestReport => ({
  type: UPDATE_LABREQUESTREPORT,
  payload: labRequestReport,
})

export const updateLabRequestReportSuccess = labRequestReport => ({
  type: UPDATE_LABREQUESTREPORT_SUCCESS,
  payload: labRequestReport,
})

export const updateLabRequestReportFail = error => ({
  type: UPDATE_LABREQUESTREPORT_FAIL,
  payload: error,
})

export const deleteLabRequestReport = labRequestReport => ({
  type: DELETE_LABREQUESTREPORT,
  payload: labRequestReport,
})

export const deleteLabRequestReportSuccess = id => ({
  type: DELETE_LABREQUESTREPORT_SUCCESS,
  id,
})

export const deleteLabRequestReportFail = error => ({
  type: DELETE_LABREQUESTREPORT_FAIL,
  payload: error,
})

export const getLabRequestReport = () => ({
  type: GET_LABREQUESTREPORT,
})

export const getLabRequestReportSuccess = labRequestReport => ({
  type: GET_LABREQUESTREPORT_SUCCESS,
  payload: labRequestReport,
})

export const getLabRequestReportFail = error => ({
  type: GET_LABREQUESTREPORT_FAIL,
  payload: error,
})
